<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "MarketplaceLayout"
    }
</script>

<style scoped>

</style>
